import React from 'react';

/**
 * ReflectionCheckpoint - Pause before coding
 *
 * Appears after learning content, before the "Start Coding" button.
 * Not required, but unavoidable - learner must see it.
 *
 * Design principles:
 * - No text field (not yet)
 * - Just a question and space to think
 * - Timing matters more than answers
 * - Prepares the mind to code
 */
function ReflectionCheckpoint({ question }) {
  if (!question) {
    return null;
  }

  return (
    <div className="my-6 p-6 bg-slate-900/50 border-l-4 border-purple-500 rounded-r-lg">
      {/* Header - quiet, not demanding */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-purple-400 text-sm font-medium">Before you code</span>
      </div>

      {/* The question - space to think */}
      <div className="text-slate-200 text-lg leading-relaxed">
        {question}
      </div>

      {/* Spacer - give room to think */}
      <div className="mt-4 text-slate-500 text-sm italic">
        Take a moment to think. There's no text box here - just you and the question.
      </div>
    </div>
  );
}

export default ReflectionCheckpoint;
